(function ($) {

    $(".content-with-image .col-two .content-wrap .btn-wrap a").each(function () {
        var link = $(this).attr("href");
        if (link.includes("https://fast.wistia.net")) {
            $(this).attr('data-module', 'MagnificPopup').addClass("magnific-video");
            var aTag = $(".content-with-image .col-two .content-wrap .btn-wrap a").attr("href");
            $(this).parent().parent().parent().parent().children(".col-two").find(".img-wrap img").wrap('<a href="' + aTag + '"></a>');
        }
    });


    $(".redesign-20 .content-with-image .col-two .img-wrap a").each(function (e) {
        var link = $(this).attr("href");
        if (link.includes("https://fast.wistia.net")) {
            $(this).attr('data-module', 'MagnificPopup').addClass("magnific-video");
        }
    });

    // var i = 0;
    // $(".content-with-image .col-two .content-wrap .btn-wrap a").on("click", function (e) {
    //     if (i === 0) {
    //         setTimeout(function () {
    //             $(".mfp-bg").eq(0).remove();
    //             $(".mfp-wrap").eq(0).remove();
    //         }, 200);
    //     }
    //     i++;
    // });

    $(window).on("load", function () {
        setTimeout(function () {
            $(".redesign-20 .content-with-form .row-wrap .right-col .form-wrap .mktoForm .mktoFormRow input[type=hidden]").parent().css("display", "none");
            $(".redesign-20 .content-with-form .row-wrap .right-col .form-wrap").css("opacity", "1");
        }, 100);
    });


    $(".redesign-20 .accordion .tab p a").css("margin-bottom", "0");
    $(".card-slider .col-wrap .item").matchHeight();
    $('.redesign-20 header .row nav ul li.login a').attr('target', '_blank');



$(window).on("load", function() {
    function checkFormIsLoaded(classname) {
        if ($(classname).hasClass("form-loaded")) {
            $(classname).find(".no-form").remove(".no-form");
            $(classname).find(".form-wrap").css("opacity", 1);
            return false
        } else {
            $(classname).find(".no-form").remove(".no-form");
            $(classname).find(".form-wrap").append('<div class="no-form message"><h6>Please disable adblocker or try refreshing the page.</h6></div>');
            $(classname).find(".form-wrap").css("opacity", 1);
            return false;
        }
    }
    const interval = setInterval(function () {
        checkFormIsLoaded(".cta-with-form");
        checkFormIsLoaded(".content-with-form");
        checkFormIsLoaded(".form-with-cta");
            $(".redesign-21 .cta-with-intro .form-wrap .mktoForm input[type='hidden']").each(function () {
                $(this).parent().css("display", "none");
                $(".redesign-21 .cta-with-intro .form-wrap .mktoForm ").css("display", "block");
                $(".redesign-21 .cta-with-intro .form-wrap").css("min-height", "100%");
                $(".redesign-21 .cta-with-intro .form-wrap .mktoForm input[type='checkbox']").css("height", "27px");
            });

    }, 1000);

});

    $(".redesign-20 footer .copyright-outer").each(function () {
        var Desc = $(this).find(".links-wrap ul li.no-link span").clone();
        $(this).find(".copyright-outer").append(Desc);
    });

})(jQuery);

$(".redesign-20 .content-with-links .col-two ul li a").each(function () {
    var link = $(this).attr("href");
    if (link.indexOf('.pdf')) {
        $(this).attr("target","_blank")
    }
});

// Force external links to open in new tab / window
(function($){
    $(function(){
        var siteName = window.location.host.replace('www.', '');
        $('a[href^="htt"]:not([target]):not([href*="www.' + siteName + '"]):not([href*="//' + siteName + '"]):not([class*="fancybox"])').attr('target', '_blank');
    });

    $(document).ready(function() {
        var $banner = $(".simple-banner");
        if ($banner.length && $banner.css("display") === "none") {
          $("header").addClass("adaptive-height");
        }
    });
})(jQuery);